import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getEspectaculos } from 'services/servicioGet';
import { EspectaculoBase } from 'utils/models/types';

interface EspectaculosState {
  espectaculos: EspectaculoBase[];
  loadingEspectaculos: boolean;
  errorEspectaculos: string | null;
}

// Estado inicial del slice
const initialState: EspectaculosState = {
  espectaculos: [],
  loadingEspectaculos: false,
  errorEspectaculos: null,
};

// Thunk para obtener los alquileres
export const fetchEspectaculos = createAsyncThunk<EspectaculoBase[], void, { rejectValue: string }>(
  'espectaculos/fetchEspectaculos',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getEspectaculos();
      return response;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : String(error));
    }
  }
);

// Slice de espectaculos
const espectaculosSlice = createSlice({
  name: 'espectaculos',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchEspectaculos.pending, state => {
        state.loadingEspectaculos = true;
        state.errorEspectaculos = null;
      })
      .addCase(fetchEspectaculos.fulfilled, (state, action) => {
        state.espectaculos = action.payload;
        state.loadingEspectaculos = false;
      })
      .addCase(fetchEspectaculos.rejected, (state, action) => {
        state.loadingEspectaculos = false;
        state.errorEspectaculos = action.payload as string;
      });
  },
});

export default espectaculosSlice.reducer;
